<template>
  <v-img :src="iconUrl()" :max-width="width" class="ma-0 elevation-1"></v-img>
</template>

<script>
export default {
  name: 'CreditCardBrandIcon',
  props: {
    creditCard: {
      required: true,
      type: Object,
    },
    width: {
      required: false,
      type: Number,
      default: 36,
    },
  },
  methods: {
    iconUrl() {
      const brand = this.$props.creditCard.brand
      let url = '/images/credit_card/'
      let file = 'credit_card.png'
      switch (brand) {
        case 'Visa': {
          file = 'visa.png'
          break
        }
        case 'MasterCard': {
          file = 'master.png'
          break
        }
        case 'American Express': {
          file = 'amex.png'
          break
        }
      }
      return url + file
    },
  },
}
</script>
